import axios from '@/utilities/api/axios';
import qs from 'qs';

export const state = initialState();

export const actions = {
  getRevisionsFor: async ({ commit }, payload) => {
    try {
      commit('mutateRevisionsForDocumentError', '');
      const { documentId, ...params } = payload;
      const res = await axios.get(
        `/documents/${documentId}/revision`,
        {
          params: {
            ...params
          }
        }
      );

      commit('mutateRevisionsForDocument', res.data);
    } catch (err) {
      commit(
        'mutateRevisionsForDocumentError',
        'There was an error fetch the document'
      );
      return;
    }
  },

  addRevisionSuggestion: async (_, payload) => {
    try {
      const { revisionId, body, ...params } = payload;
      /**
       * @DEPRECATED /revisions/${revisionId}/suggestion
       * use: PUT /revisions/{revisionId}
       *  */
      const res = await axios.post(
        `/revisions/${revisionId}/suggestion`,
        body,
        {
          params: { ...params },
          paramsSerializer: params => {
            return qs.stringify(params);
          }
        }
      );

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  updateRevisions: (_, payload) => {
    const { revisionId, body } = payload;
    return axios.put(`/revisions/${revisionId}`, body);
  }
};

export const mutations = {
  mutateRevisionsForDocument: (state, payload) => {
    state.revisionsForDocument = payload;
  },
  mutateRevisionsForDocumentError: (state, payload) => {
    state.revisionsForDocumentError = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    revisionsForDocument: {},
    revisionsForDocumentError: ''
  };
}
